module.exports = __webpack_public_path__ + "static/outlook-98284e53d6525cbdc2755abb299d7913.svg";